function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiArrowLeftShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bi:arrow-left-short"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.445 25.0002C37.445 25.4128 37.2811 25.8085 36.9894 26.1002C36.6976 26.392 36.302 26.5559 35.8894 26.5559H17.8659L24.5458 33.2326C24.6904 33.3772 24.8051 33.5489 24.8834 33.7379C24.9617 33.9269 25.002 34.1294 25.002 34.334C25.002 34.5385 24.9617 34.7411 24.8834 34.93C24.8051 35.119 24.6904 35.2907 24.5458 35.4354C24.4011 35.58 24.2294 35.6947 24.0405 35.773C23.8515 35.8513 23.6489 35.8916 23.4444 35.8916C23.2398 35.8916 23.0373 35.8513 22.8483 35.773C22.6594 35.6947 22.4876 35.58 22.343 35.4354L13.0093 26.1016C12.8644 25.9571 12.7495 25.7854 12.671 25.5964C12.5926 25.4075 12.5522 25.2048 12.5522 25.0002C12.5522 24.7956 12.5926 24.593 12.671 24.404C12.7495 24.215 12.8644 24.0433 13.0093 23.8988L22.343 14.5651C22.6351 14.273 23.0313 14.1089 23.4444 14.1089C23.8575 14.1089 24.2537 14.273 24.5458 14.5651C24.8379 14.8572 25.002 15.2534 25.002 15.6665C25.002 16.0796 24.8379 16.4758 24.5458 16.7679L17.8659 23.4446H35.8894C36.302 23.4446 36.6976 23.6085 36.9894 23.9002C37.2811 24.192 37.445 24.5876 37.445 25.0002Z",
    fill: "white",
    fillOpacity: 0.3,
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 0.3
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiArrowLeftShort);
export default __webpack_public_path__ + "static/media/bi_arrow-left-short.0081e278ef011d5d5930fb85e164d9f0.svg";
export { ForwardRef as ReactComponent };